// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingRenderer {
    constructor({ state, adapter }) {
      if (!state || !adapter) {
        throw new Error(
          "[EspacioLaserV2] Renderer requiere state y adapter."
        );
      }

      this.state = state;
      this.adapter = adapter;
      this.elements = adapter.elements;

      this.unsubscribe =
        this.state.subscribe(() => {
          this.render();
        });

      this.render();
    }

    getStateData() {
      return this.state.data || this.state;
    }

    render() {
      const state = this.getStateData();

      this.renderContent(state);
      this.renderTransform(state);
      this.renderAppearance(state);
      this.renderUI(state);
      this.syncShopify(state);
    }

    renderContent(state) {
      const previewText =
        this.elements.previewText;

      if (!previewText) return;

      const text =
        state.content?.text || "";

      previewText.textContent =
        text ||
        "Tu grabado aparecerá aquí";

      previewText.classList.toggle(
        "is-placeholder",
        !text
      );

      previewText.classList.toggle(
        "is-long",
        text.length > 18
      );

      previewText.classList.toggle(
        "is-very-long",
        text.length > 32
      );
    }

    renderTransform(state) {
      const object = this.elements.object;

      if (!object) return;

      const transform =
        state.transform || {};

      const x =
        Number(transform.x) || 0;

      const y =
        Number(transform.y) || 0;

      const rotation =
        Number(transform.rotation) || 0;

      const scale =
        Number(transform.scale) || 1;

      object.style.transform = [
        `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
        `rotate(${rotation}deg)`,
        `scale(${scale})`,
      ].join(" ");

      object.style.transformOrigin =
        "center center";
    }

    renderAppearance(state) {
      const object = this.elements.object;
      const previewText =
        this.elements.previewText;

      const appearance =
        state.appearance || {};

      if (object) {
        object.dataset.engravingFont =
          appearance.font || "default";

        object.dataset.engravingSide =
          appearance.side || "front";
      }

      if (previewText) {
        previewText.style.textAlign =
          appearance.alignment || "center";
      }
    }

    renderUI(state) {
      const object = this.elements.object;
      const ui = state.ui || {};

      if (!object) return;

      Object.entries(ui).forEach(
        ([key, value]) => {
          object.classList.toggle(
            `is-${key}`,
            Boolean(value)
          );
        }
      );

      if (this.elements.expandButton) {
        this.elements.expandButton.setAttribute(
          "aria-expanded",
          String(Boolean(ui.expanded))
        );
      }
    }

    syncShopify(state) {
      this.adapter.writeDataset(
        state.transform
      );

      this.adapter.writeHiddenInputs(state);
    }

    destroy() {
      this.unsubscribe?.();
    }
  }

  EL.EngravingRenderer =
    EngravingRenderer;
})();